export default "__VITE_ASSET__SsvUMYBO__"